
import {takeUntil} from 'rxjs/operators';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { TpwService } from '../Tpw.service';
import { ITpwCountry } from '../../model/product/tena/tpw/ITpwCountry';
import { ITpwSample } from '../../model/product/tena/tpw/ITpwSample';
import { ITpwChannel } from '../../model/product/tena/tpw/ITpwChannel';

@Component({
    selector: 'admin-tpw-sampleorder-menu',
    templateUrl: 'TpwSampleOrderMenu.component.html'
})
export class TpwSampleOrderMenuComponent implements OnDestroy {
    sampleModalVisible: boolean;
    countryModalVisible: boolean;
    channelModalVisible: boolean;

    sample: ITpwSample;
    country: ITpwCountry;
    channel: ITpwChannel;

    @Input()
    useCountry = true;

    @Input()
    useChannel = true;

    private unsubscribe: Subject<void> = new Subject();

    constructor(private tpwService: TpwService) {}

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }

    initializeSampleModal(): void {
        this.tpwService.sampleModalVisible.pipe(
            takeUntil(this.unsubscribe))
            .subscribe(visible => {
                this.sampleModalVisible = visible;
            });

        this.tpwService.sampleChanged.pipe(takeUntil(this.unsubscribe)).subscribe(sample => {
            if (sample) {
                this.sample = sample;
                if (this.useCountry) {
                    // Now show country popup
                    this.initializeCountryModal();
                }
            }
        });

        let sessionStorageSample = this.tpwService.getActiveSample();
        if (sessionStorageSample) {
            this.tpwService.sampleChanged.next(sessionStorageSample);
            this.tpwService.sampleModalVisible.next(false);
        } else {
            this.tpwService.sampleModalVisible.next(true);
        }
    }

    initializeCountryModal(): void {
        this.tpwService.countryModalVisible.pipe(
            takeUntil(this.unsubscribe))
            .subscribe(visible => {
                this.countryModalVisible = visible;
            });

        this.tpwService.countryChanged.pipe(takeUntil(this.unsubscribe)).subscribe(country => {
            if (country) {
                this.country = country;
                if (this.useChannel) {
                    // Now show channel popup
                    this.initializeChannelModal();
                }
            }
        });

        let sessionStorageCountry = this.tpwService.getActiveCountry();
        if (sessionStorageCountry) {
            this.tpwService.countryChanged.next(sessionStorageCountry);
            this.tpwService.countryModalVisible.next(false);
        } else {
            this.tpwService.countryModalVisible.next(true);
        }
    }

    initializeChannelModal(): void {
        this.tpwService.channelModalVisible.pipe(
            takeUntil(this.unsubscribe))
            .subscribe(visible => {
                this.channelModalVisible = visible;
            });

        this.tpwService.channelChanged.pipe(takeUntil(this.unsubscribe)).subscribe(channel => {
            if (channel) {
                this.channel = channel;
            }
        });

        let sessionStorageChannel = this.tpwService.getActiveChannel();
        if (sessionStorageChannel) {
            this.tpwService.channelChanged.next(sessionStorageChannel);
            this.tpwService.channelModalVisible.next(false);
        } else {
            this.tpwService.channelModalVisible.next(true);
        }
    }

    selectSample() {
        this.tpwService.sampleModalVisible.next(true);
    }

    selectCountry() {
        this.tpwService.countryModalVisible.next(true);
    }

    selectChannel() {
        this.tpwService.channelModalVisible.next(true);
    }
}
